
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';


function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');
    
     const [dishsList, setdishsList] = useState(false);

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);

    const [Beverages, setBeverages] = useState(false);
  

     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);

    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);

      useEffect(() => {
        menusData.map((item) => {
            
            if (item.id === 866) {
                setBeverages(item);
            }
        });
      }, [menusData]);
    
    
    const GoBeverages = () => {
          console.log({Beverages});
         setMenus(Beverages.menus)
    }

    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: '#d2c4a3', marginBottom: 30, textDecoration: 'none', 
                width: 330,
                maxHeight: 450,
                margin: '0px 0px 15px',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 20,
                paddingInline: 10,
                boxSizing: 'border-box',
                position: 'relative',
                borderRadius: 15,
            }}>
                <img src={image}  style={{width: '100%', height: 300, objectFit: 'cover',    borderRadius: 10,}}/>
                <h3 style={
                    {  fontWeight: '600', color: '#000', textTransform: 'uppercase', fontSize: 24, margin: '10px 0 0', textAlign: 'center', fontFamily: 'serif' }
                    }>
                    
                    {/* {data.name} */}
                    {langEng ? data.name : translate(i18n.language, data.language, data.name)}
                
                </h3>
                
                <div style={{width: '100%', margin: '0 auto'}}>
                    <p
                        className='shor-text-one'
                        style={{ fontFamily: "serif", fontSize: 16, color: '#000', textAlign: 'center', margin: 0, textTransform: 'uppercase', fontWeight: '500'}}>

                        {/* {`${data.regular_decription.replace(/\\n/g,'\n')}`} */}
                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>
            </div>
        );
    }
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showCocktails={() => {
                GoBeverages()
            }}  showLamp={ false}  goCategories={setshowCategories} showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
                <div style={{
                    background: '#4c473c',
                    width: '93%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '8px 10px',
                    gap: 15,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 12
                }}>
                    {menusData.map((item, key) => {
                            if (![767, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: '#d2c4a3',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '10px 25px',
                                    borderRadius: 10,
                                    minWidth: 'fit-content'
                            }}
                                onClick={() => { 
                                     setMenus(item.menus)
                                }}
                                >
                                    <p className='shor-text' style={{ color: 'black', fontFamily: 'serif', fontSize: 16, margin: 0, textTransform: 'uppercase', fontWeight: '500' }}>
                                        
                                    {langEng ? 
                                    `${item.name}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    item.language, 
                                    item.name, 
                                    'name'
                                )}`
                                        }
                                    </p>

                            </div>
                            }
                            
                        })}
                </div>
                <div >
                    <div style={{
                       
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start',
                            gap: '4%',
                            padding: '0px 20px 100px 20px',
                            maxHeight: 625,
                        overflow: 'scroll',
                      
                        marginTop: 15,
                        position: 'relative',
                        zIndex: 100,
                            
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                        


              
                    </div>   
                    
      
  {/* <img
              
                        style={{
                          width: 300,
                            height: 300,
                           
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                                right: 0,
                            zIndex: 1
                            
                        
                      }}
                src={require('./assets/FLAME-DECORATION.png')}
                alt="Logo"
            />  */}
                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
               
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                

            </LayoutContent>
        </div>
    );
}
export default Index;